import { Component } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'phdsoft-formly-repeat-section-expansion',
  templateUrl: './repeat-section-expasion.html',
  styleUrls: ['./repeat-section-expasion.scss'],
})
export class FormlyRepeatSectionExpansionComponent extends FieldArrayType {
  public get title() {
    return (this.field.fieldArray as FormlyFieldConfig).props?.title
           ?? (this.field.fieldArray as FormlyFieldConfig).templateOptions?.title
  }

  get btnText() {
    return (this.field.fieldArray as FormlyFieldConfig).props?.btnText
           ?? (this.field.fieldArray as FormlyFieldConfig).templateOptions?.btnText
  }
}
